export default __webpack_public_path__ + "static/media/MomentReducImg.c6416dbb.jpg";